import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import { pick } from 'Helpers/Affordances';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import RoadmapDeliverableLayout from './RoadmapDeliverableLayout';
import GuidedHouseholdReviewLayout from './GuidedHouseholdReviewLayout';

const addOverrides = (baseOverrides) => baseOverrides
  .nameOverride('goalsTitle', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('goalsSubtitle', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .done();

const roadmapDeliverableMetaOverrideSet = addOverrides(buildFacetDesignOverride());
const guidedHouseholdReviewMetaOverrideSet = addOverrides(buildBaseOverrides());

const RoadmapGoalsByTimeStepTemplate = ({ resource }) => {
  const layout = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: GuidedHouseholdReviewLayout,
  }, RoadmapDeliverableLayout);
  const metaOverrideSet = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: guidedHouseholdReviewMetaOverrideSet,
  }, roadmapDeliverableMetaOverrideSet);
  return (
    <MetaResourceRenderer
      layout={layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

RoadmapGoalsByTimeStepTemplate.defaultProps = {
};

RoadmapGoalsByTimeStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default RoadmapGoalsByTimeStepTemplate;
